// Central shortlist utility for all UI components
import { isNslpId, fetchNslpVenueIds } from '../utils/nslp_helper';

export function getShortlistedVenues() {
  const cookieValue = document.cookie.split('; ').find(row => row.startsWith('shortlisted_venue_ids='));
  
  if (!cookieValue) {
    return [];
  }
  
  const cookieData = decodeURIComponent(cookieValue.split('=')[1]);
  
  try {
    const parsed = JSON.parse(cookieData);
    if (Array.isArray(parsed)) {
      return parsed.map(id => id.toString());
    }
    if (typeof parsed === 'string' || typeof parsed === 'number') {
      return [parsed.toString()];
    }
    return [];
  } catch (error) {
    // fallback for legacy or non-JSON format
    const val = cookieData;
    if (val.includes(',')) {
      return val.split(',').map(id => id.trim()).filter(Boolean);
    }
    if (val.trim() !== '') {
      return [val.trim()];
    }
    return [];
  }
}

export function setShortlistedVenues(venueIds) {
  const cookieValue = `shortlisted_venue_ids=${JSON.stringify(venueIds)};path=/;max-age=2592000`;
  document.cookie = cookieValue;
  
  // Also update window.SHORTLIST_VENUE_IDS to keep both data sources in sync
  window.SHORTLIST_VENUE_IDS = venueIds;
  
  window.dispatchEvent(new CustomEvent('shortlist:updated', { detail: { venueIds } }));
}

export async function addVenueToShortlist(venueId) {
  const ids = getShortlistedVenues();
  
  // If it's an NSLP ID, fetch the actual venue IDs
  if (isNslpId(venueId)) {
    const venueIds = await fetchNslpVenueIds(venueId);
    
    if (venueIds.length > 0) {
      // Ensure both arrays contain strings for comparison
      const venueIdsStr = venueIds.map(id => id.toString());
      const idsStr = ids.map(id => id.toString());
      
      // Add all venue IDs from the building
      venueIdsStr.forEach(vId => {
        if (!idsStr.includes(vId)) {
          idsStr.push(vId);
        }
      });
      setShortlistedVenues(idsStr);
      return;
    }
    // If fetch failed, fall through to add NSLP ID as fallback
  }
  
  // Regular venue or fallback - ensure string comparison
  const venueIdStr = venueId.toString();
  const idsStr = ids.map(id => id.toString());
  if (!idsStr.includes(venueIdStr)) {
    idsStr.push(venueIdStr);
    setShortlistedVenues(idsStr);
  }
}

export async function removeVenueFromShortlist(venueId) {
  let ids = getShortlistedVenues();
  
  // If it's an NSLP ID, fetch and remove all associated venue IDs
  if (isNslpId(venueId)) {
    const venueIds = await fetchNslpVenueIds(venueId);
    
    if (venueIds.length > 0) {
      // Ensure both arrays contain strings for comparison
      const venueIdsStr = venueIds.map(id => id.toString());
      const idsStr = ids.map(id => id.toString());
      // Remove all venue IDs from the building
      ids = idsStr.filter(id => !venueIdsStr.includes(id));
      setShortlistedVenues(ids);
      return;
    }
    // If fetch failed, fall through to remove NSLP ID as fallback
  }
  
  // Regular venue or fallback - ensure string comparison
  const venueIdStr = venueId.toString();
  ids = ids.filter(id => id.toString() !== venueIdStr);
  setShortlistedVenues(ids);
}

export function clearShortlist() {
  document.cookie = "shortlisted_venue_ids=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  
  // Also clear window.SHORTLIST_VENUE_IDS
  window.SHORTLIST_VENUE_IDS = [];
  
  window.dispatchEvent(new CustomEvent('shortlist:cleared'));
} 